import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Logo } from 'src/components/Logo';

export const AuthBanner = () => {
  const { t } = useTranslation();

  return (
    <Flex
      flex='auto'
      boxShadow='3px 3px 13px 0 rgba(0, 0, 0, 0.35)'
      backgroundImage='linear-gradient(180deg, brand.500, brand.600, brand.700, #212020)'
      align='center'
      justify='center'
      p={5}
    >
      <Flex direction='column' align='center' color='white'>
        <Logo variant='white' />

        <Text color='white' fontSize='40px' fontWeight='bold' mt={12} textTransform='uppercase'>
          {t('components.auth_banner.auth_banner_title')}
        </Text>
      </Flex>
    </Flex>
  );
};
